import ModalAlert from '../../../../ui/Modals/ModalAlert'

function RecoverError(props) {
  return (
    <ModalAlert
      type='success'
      active={props.active}
      title='Sucesso!'
      description='Em breve enviaremos um email com as instruções de recuperação de senha.'
      textButton='Confirmar'
      onClick={props.onClick}
    />
  )
}

export default RecoverError
